module.exports = __webpack_public_path__ + "media/images/gallery/constellations/monoceros/mon_snr-f8708f133765f475cc3567b527ed72e1.gif";